import * as constantes from '../../constantes';
import React, { Component } from 'react';
import { Button , Confirm , Container , Dimmer , Header , Icon, Label,Loader, Message, Table , Pagination } from 'semantic-ui-react'; 
import {Link} from 'react-router-dom'

import auth0Client from '../Auth/Auth';
const server = constantes.REST_API_PRIVATE;

const style = {
    h1: {
      marginTop: '1em',
    },
    h2: {
      margin: '1em 0em 1em',
    },
    h3: {
      marginTop: '2em',
      padding: '2em 0em',
    },
    last: {
      marginBottom: '300px',
    },
}

export default class ListaCasos extends Component{

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            errors: [],
            listaCasos: [],

            confirmEliminarCasoOpen: false , 
            casoIdDelete : null ,
            dimmerEliminarCaso :  false ,

            activePage:1,
            totalPages:0,
            totalRows:0,
            begin: 0,
            end: 5
        };

        this.onChange = this.onChange.bind(this);
        //this.nuevoCaso = this.nuevoCaso.bind(this);
        //this.setShowModalEdit =this.setShowModalEdit.bind(this) ; 
        this.eliminarCaso = this.eliminarCaso.bind(this);

    }

    componentDidMount() {
        auth0Client.isExpired();
        this.cargarListaDeCasosPaginado( 1 );
    }

    onChange (e, pageInfo) {
        let METHODNAME = 'onChange - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'activePage = ' + pageInfo.activePage );

        this.setState({
            activePage : pageInfo.activePage
        });

        this.cargarListaDeCasosPaginado( pageInfo.activePage );

    };

    handleChangeBoolean( name , mostrar ){
        this.setState({
            [name]: mostrar
        });
    }

    async cargarListaDeCasosPaginado( paginaActiva ){
        let METHODNAME = 'cargarListaDeCasosPaginado - ';
        console.log(METHODNAME + 'INI');
 
        console.log(METHODNAME + 'paginaActiva = ' + paginaActiva );

        let url = server+`/casos`;

        let _rows = 10;
        let _begin = 0 ;
        let _end = _rows - 1;
        let _totalPaginas = 0;

        if( paginaActiva > 1 ){
            _begin = paginaActiva * _rows ;
            _end = _rows - 1; 
        }

        let dataForm = null;
        dataForm = {
            "authUsername" : localStorage.getItem('usuario'),
            "pagina" : paginaActiva-1,
            "filas" : _rows
        }
        
        fetch(
            url , {
            method: 'POST',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            },
            body:JSON.stringify(dataForm)
        })
        .then(res => res.json())
        .then(
            
            (result) => {
                console.log(METHODNAME + 'RESULTADO DE LISTA DE CASOS');
                
                _totalPaginas = result.totalPaginas;

                this.setState({
                    isLoaded: true,
                    listaCasos: result.listaCasos,
                    totalRows: result.cantidadRegistros,
                    activePage : paginaActiva, 
                    totalPages: _totalPaginas,
                    begin: _begin,
                    end: _end
                });
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
                console.log(METHODNAME + 'error = ' + error );
                this.setState({
                    isLoaded: true,
                    error
                });
            }
        )
        console.log(METHODNAME + 'FIN');
    }

    preEliminarCaso( casoId ){
        this.setState({
            confirmEliminarCasoOpen: true , 
            casoIdDelete : casoId ,
            dimmerEliminarCaso :  false 
        });
    }

    handleDetail( caso ){
        let METHODNAME = 'handleDetail - ';
        console.log(METHODNAME + 'INI');

        console.log(METHODNAME + 'Caso Id = ' + caso.casoId );
/*
        let path = `/resultadoCaso`;
        let navigate = useNavigate();
        navigate( path , { state : caso } );
*/
        console.log(METHODNAME + 'FIN');
    }

    handleDismiss = ( nombre ) => {

        this.setState({ [nombre]: null })

        setTimeout(() => {
            this.setState({ visible: true })
        }, 2000)
    }
    
    async eliminarCaso(){
        let METHODNAME = 'eliminarCaso - ';
        console.log( METHODNAME + 'INI ');
   
        if( this.state.casoIdDelete === null ){
            console.log('No hay ID de caso para eliminar');
            return;
        }

        this.setState({ 
            dimmerEliminarCaso : true  
        });

        let url =  `${server}/caso/${this.state.casoIdDelete}/`;
        let dataForm = {
            authUsername : localStorage.getItem('usuario'),
        }
        const json = await fetch( url , {
            method: 'DELETE',
            headers:{
                'Accept':'application/json',
                'Content-Type':'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('AccessToken'),
            } ,
            body:JSON.stringify(dataForm)
        }).then((result) => {
           
            result.json().then((resp) => {

                if( resp.resultado === 'true' ){ 
                    
                    this.setState({
                        confirmEliminarCasoOpen: false , 
                        casoIdDelete : null ,
                        dimmerEliminarCaso :  false  
                    });

                    this.cargarListaDeCasosPaginado(1);

                }else{
                    console.warn(METHODNAME +  'error : ' + resp.error );

                    this.setState({ 
                        dimmerEliminarCaso : false  
                    });

                }

            }).catch((error) => { 
                console.error(METHODNAME +  'Error al procesar respuesta: ' + error)
                this.setState({ 
                    dimmerEliminarCaso : false  
                });
            });

        }).catch((error) => { 
            console.error(METHODNAME +  'Server Error: ' + error)
        });
        return json;
    }

    generaBotoneVer(tipoResultado , casoId){
        
        return (
            <div>
            
            { ( tipoResultado  ) ? 
                    <Link to={`/resultadoCaso/${casoId}`}> 
                        <Button color='orange' animated="vertical" size='mini' title='Ver resultado' >
                            <Button.Content visible> <Icon name="search" /></Button.Content>
                            <Button.Content hidden>
                            Ver
                            </Button.Content>
                        </Button>
                    </Link> 
            :                 
                <div></div>
            }
            </div>
        )
    }

    generaBotones( estado , tipoResultado , casoId ){
       
        return (
            <div>
            
            { ( tipoResultado && estado === 3 ) ?
                <div>
                    <Link to={`/resultadoCaso/${casoId}`}> 
                        <Button color='orange' animated="vertical" size='mini' title='Ver resultado' >
                            <Button.Content visible> <Icon name="search" /></Button.Content>
                            <Button.Content hidden>
                            Ver
                            </Button.Content>
                        </Button>
                    </Link>

                    <Button color='red' animated="vertical" size='mini'
                            onClick={ () => this.preEliminarCaso(casoId)}  >
                        <Button.Content visible><Icon name="trash alternate outline"/></Button.Content>
                        <Button.Content hidden>
                            Eliminar
                        </Button.Content>
                    </Button>
                </div>
            :                 
                <div>
                    <Link to={`/datosCaso/${casoId}`}> 
                        <Button color='blue' size='mini' title='Completar Expediente' > 
                            Completar 
                        </Button>
                    </Link>

                    <Link to={`/analisis/${casoId}`}> 
                        <Button color='green' size='mini' title='Analizar el Caso' > 
                            Analizar Caso 
                        </Button>
                    </Link>
                </div>               
            }
            </div>
        )
    }

    render() {

        const { error, isLoaded, listaCasos , activePage , totalPages } = this.state;

        if (error) {
            //return <div>Error: {error.message}</div>;
            return (
                <Message
                  onDismiss={this.handleDismiss}
                  header='Ha ocurrido un error:'
                  content={error.message}
                />
              )

        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {

            return(
            <Container>

            <Header as='h2' content='Lista de Expedientes en Analisis o Por Analizar' className='h2' textAlign='center' />
          
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Numero</Table.HeaderCell>
                            <Table.HeaderCell>Expediente</Table.HeaderCell>
                            <Table.HeaderCell>Fecha Inicio</Table.HeaderCell>
                            <Table.HeaderCell>Fecha Fin</Table.HeaderCell>
                            <Table.HeaderCell>Estado</Table.HeaderCell>
                            <Table.HeaderCell>Resultado</Table.HeaderCell>
                            <Table.HeaderCell>Tipo Resolución</Table.HeaderCell>
                            <Table.HeaderCell>Ponencia Recomendada</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
            
                    <Table.Body>
                        
                        { listaCasos && listaCasos.map(caso => (
                            <Table.Row  key={caso.casoId}>
                                <Table.Cell> <Label ribbon>{caso.casoId}</Label> </Table.Cell>
                                <Table.Cell>{caso.cnumExpediente}</Table.Cell>
                                <Table.Cell>{caso.fechaInicioAnalisis}</Table.Cell>
                                <Table.Cell>{caso.fechaFinAnalisis}</Table.Cell>
                                <Table.Cell>{caso.estadoTxt}</Table.Cell>
                                <Table.Cell>{caso.tipoResultado ? caso.tipoResultado.nombre : '--'}</Table.Cell>
                                <Table.Cell>{caso.etapa ? caso.etapa.etapa : '--'}</Table.Cell>
                                <Table.Cell>
                                    {caso.estado > 0 &&
                                        this.generaBotones( caso.estado , caso.tipoResultado , caso.casoId )                                    
                                    }
                                    {caso.estado === 0 &&
                                        this.generaBotoneVer( caso.tipoResultado , caso.casoId )                                    
                                    }
                                </Table.Cell>
                            </Table.Row>
                        ))}

                    </Table.Body> 
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='8' textAlign='center'>
                                <Pagination 
                                    activePage={activePage} 
                                    onPageChange={this.onChange}
                                    totalPages={totalPages} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
            
                </Table>                

            <div>
                
                <Link to="/datosCaso/0"> 
                    <Button color='green' title='Analizar caso nuevo'  >
                        <Icon name='folder open outline' />
                        Haga clic aquí para analizar un nuevo expediente
                    </Button>
                </Link>
            </div>

                <Confirm
                    open={this.state.confirmEliminarCasoOpen}
                    header='Eliminar Registro'
                    content='¿Está seguro que desea eliminar el registro seleccionado?'
                    onCancel={ () => this.handleChangeBoolean('confirmEliminarCasoOpen', false )} 
                    onConfirm={this.eliminarCaso}
                />

                <Dimmer active={this.state.dimmerEliminarCaso} inverted >
                    <Loader>Loading</Loader>
                </Dimmer>
             
            </Container>
            );

        }
    }
}